import { Box, Button, Typography } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';

const SearchFiltersRow = styled(Box)({
  display: 'flex',
  gap: '16px'
});

const SkillsActionsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center'
});

const SkillsButtonsRow = styled(Box)({
  display: 'flex',
  gap: '16px'
});

const FullWidthBox = styled(Box)({
  width: '100%'
});

const ResultCountText = styled(Typography)({
  marginTop: '8px',
  textAlign: 'right'
});

const CloneNoteText = styled(Typography)({
  marginBottom: '8px'
});

const BoldSpan = styled.span({
  fontWeight: 'bold'
});

const CloneFromTitle = styled(Typography)({
  marginBottom: '8px'
});

const CloneFormContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
});

const AddSubSkillFormContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
});

const EditSubSkillContainer = styled(Box)({
  display: 'flex',
  gap: '16px',
  marginBottom: '16px',
  alignItems: 'flex-end',
  flexWrap: 'wrap'
});

const EditSubSkillActionContainer = styled(Box)({
  display: 'flex',
  gap: '8px'
});

const ViewEditActionsContainer = styled(Box)({
  display: 'flex',
  gap: '16px',
  marginRight: '28px'
});

const ViewEditCancelButton = styled(Button)({
  border: `1px solid ${pallet.primary}`
});

const ViewEditContentContainer = styled(Box)({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: '16px'
});

const ViewEditHeaderRow = styled(Box)({
  display: 'flex',
  gap: '16px',
  marginTop: '8px'
});

const viewEditPaperPropsSx = {
  width: '100vw',
  height: '100vh',
  margin: '8px',
  maxHeight: 'calc(100vh - 32px)',
  maxWidth: 'calc(100vw - 32px)',
  borderRadius: '16px'
};

export {
  SearchFiltersRow,
  SkillsActionsContainer,
  SkillsButtonsRow,
  FullWidthBox,
  ResultCountText,
  CloneNoteText,
  BoldSpan,
  CloneFromTitle,
  CloneFormContainer,
  AddSubSkillFormContainer,
  EditSubSkillContainer,
  EditSubSkillActionContainer,
  ViewEditActionsContainer,
  ViewEditCancelButton,
  ViewEditContentContainer,
  ViewEditHeaderRow,
  viewEditPaperPropsSx
};
